import * as React from "react";
import { SVGProps, memo } from "react";
const SvgDataCatalogLineageMetricActive = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    role="img"
    {...props}
  >
    <path
      fill="#333"
      fillRule="evenodd"
      d="M18 5c.51 0 .935.388.993.884L19 6v13c0 .51-.388.935-.884.993L18 20H5c-.51 0-.935-.388-.993-.884L4 19V6c0-.51.388-.935.884-.993L5 5h13Zm0 1H5v13h13V6Zm-1.878 3.84.707.706-4.591 4.531L9.2 12.193l-1.993 1.993-.707-.706 2.673-2.674 3.038 2.884 3.911-3.85Z"
    />
  </svg>
);
const Memo = memo(SvgDataCatalogLineageMetricActive);
export default Memo;
